module.exports = __webpack_public_path__ + "img/black-vip-section2-bg.5baebcc9.png";